import { render, staticRenderFns } from "./APSaleReturnHistory.vue?vue&type=template&id=7a9b20bc&scoped=true&"
import script from "./APSaleReturnHistory.vue?vue&type=script&lang=js&"
export * from "./APSaleReturnHistory.vue?vue&type=script&lang=js&"
import style0 from "./APSaleReturnHistory.vue?vue&type=style&index=0&id=7a9b20bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9b20bc",
  null
  
)

component.options.__file = "APSaleReturnHistory.vue"
export default component.exports